import React from "react"
import * as styles from "./BreadcrumbWrapper-tw-styles"
import BreadCrumb from "../BreadCrumb/BreadCrumb"
import PropTypes from "prop-types"
 
const BreadcrumbWrapper = props => {
  const { variant } = props
  const style = styles[variant] || styles.defaultStyle
  const { breadcrumbWrapper, ContainerTwo, ContainerThree, ContainerFour, leftWrapper } = style
 
  return (
    <div className={breadcrumbWrapper}>
      <div className={ContainerTwo}>
        <div className={ContainerThree}>
          <div className={ContainerFour}>
            <div className={leftWrapper}>{<BreadCrumb {...props} />}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
 
BreadcrumbWrapper.propTypes = {
  variant : PropTypes.any
}
 
export default BreadcrumbWrapper